Game.Utils.Inventory = {

	db: [],

	init: function() {

		this.load();

	},

	collect: function( key, value ) {

		if ( ! value ) {
			value = true;
		}

		this.db[ key ] = value;

		this.save();

	},

	haveItem: function( key ) {

		if ( 'undefined' !== typeof this.db[key] ) {
			return true;
		}

		return false;

	},

	save: function() {

		// console.table( this.db );

	},

	load: function() {

		this.db = [];

	},

};
